// Ausserbetriebsetzung

// state
const state = {
    wantedProducts: [],
    // W�rmepumpe / �lheizung / Pelletheizung
    heatingCurrentSystem: '',
    heatingUsage: null,
    heatingCurrentSystemInstallationYear: null,
    //W�rmepumpen-Boiler
    boilerInstallationYear: null,
    boilerCurrentSize: '',
    boilerDesiredSize: '',
    //Brennerersatz
    blowerUsage: null,
    blowerInstallationYear: null,
    //Photovoltaikanlage
    photoPowerSaver: ''
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
    // address fields
    setWantedProducts(state, newValue) {
        state.wantedProducts = newValue;
    },
    // W�rmepumpe / �lheizung / Pelletheizung
    setHeatingCurrentSystem(state, newValue) {
        state.heatingCurrentSystem = newValue;
    },    
    setHeatingUsage(state, newValue) {
        state.heatingUsage = newValue;
    },
    setHeatingCurrentSystemInstallationYear(state, newValue) {
        state.heatingCurrentSystemInstallationYear = newValue;
    },
    //W�rmepumpen-Boiler
    setBoilerInstallationYear(state, newValue) {
        state.boilerInstallationYear = newValue;
    },
    setBoilerCurrentSize(state, newValue) {
        state.boilerCurrentSize = newValue;
    },
    setBoilerDesiredSize(state, newValue) {
        state.boilerDesiredSize = newValue;
    },
    //Brennerersatz
    setBlowerUsage(state, newValue) {
        state.blowerUsage = newValue;
    },
    setBlowerInstallationYear(state, newValue) {
        state.blowerInstallationYear = newValue;
    },
    //Photovoltaikanlage
    setPhotoPowerSaver(state, newValue) {
        state.photoPowerSaver = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}